import { Directions } from 'components/modules/public/layout/sections/blocks/TwoCol/types';

import Component from './component';

Component.defaultProps = {
    list: [],
    direction: Directions.Default,
};

export default Component;